/**
 * Get the price of an item
 *
 * @param itemId
 * @param quantity
 * @param callback
 */
window.getPrice = (itemId, quantity, callback) => {
    $.ajax({
        url: '/api/v1/buy',
        method: 'POST',
        data: JSON.stringify({
            items: {
                [itemId]: {
                    itemId: itemId,
                    quantities: [quantity]
                },
            }
        }),
        success: function (response) {
            const price = response.items[itemId]['prices'][quantity];
            callback(price);
        }
    });
}
